import React from "react"
import PropTypes from "prop-types"
import withStyles from "@material-ui/core/styles/withStyles"

import LinearProgress from '@material-ui/core/LinearProgress';
import Transition from "react-transition-group/Transition"

import classnames from "classnames"
import { fade } from "@material-ui/core/styles/colorManipulator"

const EXIT_DURATION_MS = 500

const styleSheet = theme => ({
  root: {
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    zIndex: theme.zIndex.tooltip,
    opacity: 0,
  },

  in: {
    opacity: 1,
  },

  transition: {
    transition: theme.transitions.create("opacity", {
      duration: EXIT_DURATION_MS / 2,
      delay: EXIT_DURATION_MS / 2,
    }),
  },

  exiting: {
    opacity: 0,
  },

  cover: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    opacity: 0,
    backgroundColor: fade(theme.palette.common.white, 0.75),
    transition: theme.transitions.create("opacity", {
      duration: EXIT_DURATION_MS,
    }),
    zIndex: theme.zIndex.tooltip,
  },

  coverIn: {
    opacity: 1,
  },
})

class DialogProgress extends React.Component {
  static propTypes = {
    cover: PropTypes.bool,
    mode: PropTypes.string,
    value: PropTypes.number,
    in: PropTypes.bool,
    scrolled: PropTypes.bool,
  }

  state = {}

  componentWillUnmount() {
    this._clearInTimeout()
  }

  _handleExiting = () => {
    this._clearInTimeout()
    this.setState({ exiting: true, in: false, coverIn: false })
  }
  _handleExited = () => this.setState({ exiting: false })

  _handleEntering = () => {
    setTimeout(() => this.setState({ exiting: false, coverIn: true }))
    // Provide a small timeout to avoid flashing the progress for very fast
    // responses.
    this._inTimeout = setTimeout(() => this.setState({ in: true }), 250)
  }

  _clearInTimeout() {
    if (this._inTimeout) {
      clearTimeout(this._inTimeout)
      delete this._inTimeout
    }
  }

  render() {
    const {
      classes,
      className: classNameProp,
      children,
      cover,
      value: valueProp,
      mode: modeProp,
      in: inProp,
      scrolled,

      ...otherProps
    } = this.props

    const { exiting } = this.state

    const value = exiting ? 100 : valueProp
    const mode = exiting ? "determinate" : modeProp

    const className = classnames(
      classes.root,
      {
        [classes.exiting]: exiting,
        [classes.transition]: !cover,
        [classes.in]: this.state.in,
      },
      className
    )

    const coverClassName = classnames(classes.cover, {
      [classes.coverIn]: this.state.coverIn,
    })

    return (
      <Transition
        in={!!inProp}
        timeout={EXIT_DURATION_MS}
        onEntering={this._handleEntering}
        onEntered={this._handleEntered}
        onExiting={this._handleExiting}
        onExited={this._handleExited}
        appear
        mountOnEnter
        unmountOnExit
      >
        <div>
          {cover && <div className={coverClassName} key="cover" />}
          <LinearProgress className={className} value={value} mode={mode} {...otherProps} />
        </div>
      </Transition>
    )
  }
}

export default withStyles(styleSheet)(DialogProgress)



// WEBPACK FOOTER //
// ../ui-kit/src/components/ui-Dialog/DialogProgress.js